import Datetime from 'react-datetime';

export function getFormattedDate(date) {
  const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
  const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);

  return `${day}.${month}.${date.getFullYear()}`;
};

export function convertUTCToLocalDate(date) {
  if (!date) {
    return date;
  }

  date = Datetime.moment(date);
  
  date = new Date(
    date.year(), date.month(), date.date(),
    date.hour(), date.minute(), date.second()
  );

  return date;
};

export function convertLocalToUTCDate(date) {
  if (!date) {
    return date;
  }
  date = new Date(date);
  date = new Date(
    date.getFullYear(), date.getMonth(), date.getDate(),
    date.getHours(), date.getMinutes(), date.getSeconds()
  );
  return date;
};

const isSameDay = (d1, d2) =>
  d1.getDate() === d2.getDate() &&
  d1.getMonth() === d2.getMonth() &&
  d1.getFullYear() === d2.getFullYear();

export function isToday(date) {
  const today = new Date();
  return isSameDay(date, today);
};

export function isYesterday(date) {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return isSameDay(date, yesterday);
};
